import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormConsulate, { ConsulateForm } from 'system/geographic/components/consulate/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonConsulateCrumbs } from '../constants';
import TerritoryAutoComplete from 'system/geographic/components/consulate/form/territory/autocomplete';
import { Grid } from '@mui/material';
import { toast } from 'react-toastify';

const ConsulateNewPage = (): React.ReactElement => {
  const { post: insertConsulate } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/consolato`);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: ConsulateForm | undefined) => {
      insertConsulate({
        nome: formValues?.name,
        categoria: formValues?.category,
        indirizzo: formValues?.address || '',
        territori:
          formValues?.territory?.map((territory) => ({
            key: {
              codice: territory.code,
            },
          })) || [],
        sede: Number.parseInt(formValues?.municipality?.code || '', 10),
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/estero/consolato');
      });
    },
    [insertConsulate, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonConsulateCrumbs, { name: 'Nuovo Consolato' }]} />
      <FormConsulate
        title="Nuovo Consolato"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/geografiche/estero/consolato');
        }}
      >
        {(form) => (
          <Grid item xs={12} md={8}>
            <TerritoryAutoComplete
              selectedValue={form?.values.territory ? form?.values.territory[0] : null}
              handleChange={(element) => {
                const newTerritories = form?.values.territory || [];
                const foundElement = newTerritories.find(
                  (territory) => territory.code === element?.code
                );
                if (!foundElement) {
                  form?.setFieldValue('territory', [...newTerritories, element]);
                }
              }}
              error={form?.touched.territory && Boolean(form?.errors.territory)}
            />
          </Grid>
        )}
      </FormConsulate>
    </Fragment>
  );
};

ConsulateNewPage.displayName = 'Consulate new page component';

export default ConsulateNewPage;
